import { useState } from "react";
import { deepCopy, updateNestedValue } from "../../../../../../common/services/common.service";
import Popup from "../../../../../../common/components/popup";
import PayoutsBasicInfoComponent from "./payouts-basic-info.component";

export const PayoutPopup = ({ 
  selectedPayout,
  closeModal,
  handleSavePayout,
}: any) => {
  console.log('selectedPayout', selectedPayout)
    const [localAttribute, setLocalAttribute] = useState(deepCopy(selectedPayout));

    const handleLocalFormChange = ({path, value}: any) => {
      // setLocalAttribute(prev => ({
      //   ...prev,
      //   [field]: value,
      // }));
      console.log('selectedPayout, path, value', selectedPayout, path, value)
      const updatedData = updateNestedValue(selectedPayout, path, value)
  
      console.log('updatedData', updatedData)
      setLocalAttribute({...updatedData});
    };

    const handleFormSubmit = () => {
      // setSelectedProductSpecificationAttributeItem(localAttribute);
      handleSavePayout(localAttribute)
    };

    return (
      <>
        <Popup onClose={closeModal}>
          <PayoutsBasicInfoComponent
            onClose={closeModal}
            handleInnerFormChange={handleLocalFormChange}
            selectedPayout={selectedPayout}
            handleFormSubmit={handleFormSubmit}
          />
        </Popup>
      </>
    )
  }